<!--
  navItem "Berechnete Vermittler" — the rule set that derives an ADDITIONAL agent for an event row
  out of the rule's condition set and the already resolved trigger agent (Anforderung §4).

  The table is the generic child table; the only addition is the pre-filter on the target
  commission component, for the same reason the Matrix-Zuordnung tab carries one: the mandatory
  target component partitions the rule set. The pre-filter is a READ aid — it narrows the list and
  does not change how rows are created; the create form still pre-fills the provision type and lets
  the user pick the target component.

  Filter wording is "Zielkomponente" throughout — label, placeholder and hint. NOT "Provisionsart":
  inside this object page that word is the label of the PARENT entity cp.ProvisionType
  (@UiEntityInfo(label = "Provisionsart"), ProvisionType.java:62), so "Alle Provisionsarten" would
  read as "filter across provision types", which is not what this control does. The entity actually
  filtered is cp.ProvisionTypeComponent, backend label "Provisionsart-Komponente".
-->
<div class="cp-provision-type-calculated-agent">

    @if (initialized && provisionTypeId) {

        @if (componentOptions.length) {
            <div class="flex align-items-center flex-wrap gap-2 mb-3">
                <i class="fa-solid fa-filter text-color-secondary"></i>
                <label for="cpCalculatedAgentComponentFilter" class="text-sm text-color-secondary">
                    Zielkomponente
                </label>
                <p-select
                        inputId="cpCalculatedAgentComponentFilter"
                        styleClass="w-16rem"
                        [options]="componentOptions"
                        optionLabel="name"
                        optionValue="id"
                        [ngModel]="selectedComponentId"
                        (ngModelChange)="onComponentChange($event)"
                        [showClear]="true"
                        placeholder="Alle Zielkomponenten">
                </p-select>
                <span class="text-sm text-color-secondary">
                    Zeigt nur die Regeln der gewählten Zielkomponente — die vollständige Zeile
                    wird im Detail-Dialog gepflegt.
                </span>
            </div>
        }

        <!--
          Wildcard legend. The three trigger columns are nullable, and NULL means "matches anything"
          — rendered as an empty cell, which looks exactly like "nicht gepflegt". The contract side
          is the condition set: an empty set is shown as "Alle Verträge (unbedingt)" by the
          Bedingungssatz column itself. The rule is stated once above the table instead of guessed
          per column.
        -->
        <div class="flex align-items-center gap-2 mb-3">
            <i class="fa-solid fa-circle-info text-color-secondary"></i>
            <span class="text-sm text-color-secondary">
                Leerer Trigger = <strong>beliebig</strong> (Wildcard). Auslösender Vermittler und
                auslösende Gruppe gelten gemeinsam als UND-Bedingung; sind alle drei Trigger leer,
                greift die Regel allein über ihren Bedingungssatz — ohne Bedingungssatz für alle
                Verträge.
            </span>
        </div>

        <cp-provision-type-child-table
                [provisionTypeId]="provisionTypeId"
                [child]="child"
                [additionalFilters]="additionalFilters"
                (onJumpToConditionSet)="onJumpToConditionSet.emit($event)">
        </cp-provision-type-child-table>

    } @else if (initialized) {
        <p-message severity="info" text="Kein Provisionstyp ausgewählt." styleClass="w-full"></p-message>
    } @else {
        <p-skeleton height="12rem"></p-skeleton>
    }

</div>
